<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}个科室</span>
      </div>
      <div class="header">
        <div class="left">
          <el-button v-if="tableAcl.indexOf('Add') != -1" class="btn primary" type="primary" size="small"
            v-preventReClick @click="handleAdd">新增</el-button>
          <el-button v-if="tableAcl.indexOf('Remove') != -1" class="btn" size="small" :disabled="multiple"
            v-preventReClick @click="handleDelete">
            {{ cancelButtonText }}
          </el-button>
          <el-button class="btn primary" type="primary" size="small" v-preventReClick @click="shareEvt">库存共享</el-button>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset">重置</span>
        </div>
      </div>
      <el-table ref="multipleTable" border row-key="id" :data="tableData" :max-height="tableHeight" style="width: 100%"
        @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
        </el-table-column>
        <el-table-column prop="no" label="编码" width="120">
          <template slot-scope="scope">
            <span>
              <el-link type="primary" @click="handleInfo(scope.row)">{{ scope.row.no }}</el-link>
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="name" label="名称" min-width="130" />
        <el-table-column prop="deptCategoryName" label="科室类别" min-width="130">
          <template slot-scope="scope">
            {{ scope.row.deptCategoryName??'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="parentDeptName" label="上级科室" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.parentDeptName??'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="leaderName" label="负责人" min-width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{  scope.row.leaderNames??'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="sharedDeptNames" label="共享科室" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.sharedDeptNames? scope.row.sharedDeptNames:'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="createdTime" label="创建时间" width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.createdTime)) }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="170">
          <template slot-scope="scope">
            {{ parseTime(new Date(scope.row.updateTime)) }}
          </template>
        </el-table-column>
        <el-table-column prop="desc" label="备注" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.desc??'-' }}
          </template>
        </el-table-column>
        <el-table-column prop="stateName" label="状态" min-width="80" show-overflow-tooltip>
          <template slot-scope="scope">
            <span :class="{
              enable: scope.row.state == 1,
              forbidden: scope.row.state == 0,
            }">{{ scope.row.stateName }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="operation" fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <!-- <el-button type="text" v-preventReClick @click="handleInfo(scope.row)" class="color-blue">查看</el-button> -->
            <el-button v-if="tableAcl.indexOf('Edit') != -1" type="text" v-preventReClick
              @click="handleUpdate(scope.row)" class="margin-left20 color-blue">编辑</el-button>
            <el-button v-if="tableAcl.indexOf('Remove') != -1" type="text" v-preventReClick
              @click="handleDelete(scope.row)" class="margin-left20 color-blue">{{ scope.row.state === 0 ? "启用" : "禁用"
              }}</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="title + '科室'" :visible.sync="open" :center="true" width="500px" :before-close="cancel"
        :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="form" :model="form" :rules="rules">
          <el-form-item label="编码" prop="no">
            <el-input v-model="form.no" :disabled="!editMode" placeholder="请填写编码"></el-input>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="form.name" :disabled="!editMode" placeholder="请填写名称"></el-input>
          </el-form-item>

          <el-form-item label="科室类别">
            <el-select v-model="form.category" :disabled="!editMode" placeholder="请选择科室类别" style="width:100%">
              <el-option v-for="item in STATIC_Category" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="上级科室">
            <el-select v-model="form.parentDeptName" :disabled="!editMode" placeholder="请选择上级科室" filterable
              :filter-method="getDepts" @change="deptChange" style="width:100%">
              <el-option v-for="item in STATIC_Depts" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="负责人">
            <el-select v-model="form.leadersName" :disabled="!editMode" placeholder="请选择负责人" filterable
              :filter-method="getUsers" @change="userChange" style="width:100%" multiple>
              <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="关联一级库" prop="oneLevelWarehouseIdArr">
            <el-select v-model="form.oneLevelWarehouseIdArr" :disabled="!editMode" placeholder="请选择关联一级库" multiple
              filterable :filter-method="getOneLevelWarehouses" @change="warehouseChange" style="width:100%">
              <el-option v-for="item in STATIC_OneLevelWarehouses" :key="item.id" :label="item.name"
                :value="item.id + ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="病区" v-if="this.system_setting.IsUseWard">
            <el-select v-model="form.wardIdArr" :disabled="!editMode" placeholder="请选择关联病区" multiple filterable
              :filter-method="getWards" @change="wardChange" style="width:100%">
              <el-option v-for="item in STATIC_Wards" :key="item.id" :label="item.name"
                :value="item.id + ''"></el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="共享科室" prop="sharedDeptNames">
            <el-select v-model="form.sharedDeptIdsArr" :disabled="!editMode" placeholder="请选择共享科室" multiple
              filterable :filter-method="getDepts1" @change="sharedDeptChange" style="width:100%">
              <el-option v-for="item in STATIC_Depts1" :disabled="item.id == form.id" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="备注">
            <el-input v-model="form.desc" :disabled="!editMode" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item label="启用状态">
            <el-switch v-model="form.state" :disabled="!editMode" active-color="#286AB4" inactive-color="#D4D4D4"
              :active-value="1" :inactive-value="0">
            </el-switch>
            <span v-if="form.state">已启用</span>
            <span v-else>已禁用</span>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button class="btn" size="small" v-preventReClick @click="cancel">取 消</el-button>
          <my-button class="btn primary" type="primary" v-if="editMode" size="small" v-preventReClick @click="submit">确
            定</my-button>
        </div>
      </el-dialog>
    </div>

    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper"
        :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange"
        :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
    <el-dialog title="库存共享" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div>
        <el-form label-position="top" label-width="80px" ref="form" :model="share" :rules="rules">

        <el-form-item label="请选择库存共享的科室：" prop="sharedDeptNames">
          <el-select v-model="share.sharedDeptIdsArr"  placeholder="请选择共享科室" multiple
            filterable :filter-method="getDepts1" @change="sharedDeptIdsChange" style="width:100%">
            <el-option v-for="item in STATIC_Depts1" :disabled="item.id == form.id" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>

        <!-- <p> </p>
        <div class="center">
          <el-tag v-for="(tag,index) in tags" :key="tag.name" closable @close="tagClose(index)">
            {{ tag.name }}
          </el-tag>
        </div> -->
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="tagsSubmit">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import {
  GetDepts,
  SaveDept,
  UpdateDeptStatesById,
  GetWards,
  SaveDeptShare,
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";

export default {
  mixins: [GetDataMixin],
  data () {
    return {
      // 查询条件
      query: {
        keyWord: "",
        pageSize: 10,
        pageIndex: 1,
      },
      // 列表数据
      tableData: [],
      // 列表总数
      total: 0,
      // 弹出编辑框
      open: false,
      editMode: false,
      // 新增、编辑的数据
      form: {},
      // 多选框数据
      ids: [],
      multipleSelection: [],
      // 列表多选
      multiple: true,
      rules: {
        no: [{
          required: true,
          message: "请输入编码",
          trigger: "blur"
        }],
        name: [{
          required: true,
          message: "请选择名称",
          trigger: "blur"
        }],
        wardIdArr: [{
          required: true,
          message: "请选择病区",
          trigger: "blur"
        }],
        oneLevelWarehouseIdArr: [{
          required: true,
          message: "请选择关联一级库",
          trigger: "blur"
        }],
      },
      cancelButtonText: "禁用",
      dialogVisible: false,
      share:{},
      tags: []
    };
  },
  methods: {
    handleSelectionChange (selection) {
      this.multipleSelection = selection;
      this.ids = selection.map((item) => item.id);
      this.multiple = !selection.length;

      this.cancelButtonText =
        selection && selection.length > 0 && selection[0].state == 0 ?
          "启用" :
          "禁用";
    },
    // 获取列表
    getData () {
      // console.log(this.system_setting.IsUseWard, "this.system_setting.IsUseWard")
      GetDepts(this.query).then((res) => {
        this.tableData = res.returnData.data;
        this.total = res.returnData.totalCount;
      });
    },
    // 新建
    handleAdd () {
      this.open = true;
      this.resetForm();
      this.getDepts("");
      this.getDepts1("");
      this.editMode = true;
      this.title = "新建";
    },
    handleInfo (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      this.form.oneLevelWarehouseIdArr = this.form.oneLevelWarehouseIds ? this.form.oneLevelWarehouseIds.split(';') : []
      if (this.form.oneLevelWarehouses) {
        this.form.oneLevelWarehouses.map(item => {
          let m = this.STATIC_OneLevelWarehouses.find(e => e.id == item.id)
          if (!m) {
            this.STATIC_OneLevelWarehouses.push(item)
          }
        })
      }
      let sharedDeptIdsArr = this.form.sharedDeptIds ? this.form.sharedDeptIds.split(';') : []
      let IdsArr = sharedDeptIdsArr.map(Number)
      this.$set(this.form, 'sharedDeptIdsArr', IdsArr)
      if (this.form.sharedDeptIdsArr) {
        this.form.sharedDeptIdsArr.map(item => {
          let m = this.STATIC_Depts.find(e => e.id == item.id)
          if (!m) {
            this.STATIC_Depts.push(item)
          }
        })
      }
      this.form.wardIdArr = this.form.wardIds ? this.form.wardIds.split(';') : []
      if (this.form.wards) {
        this.form.wards.map(item => {
          let m = this.STATIC_Wards.find(e => e.id == item.id)
          if (!m) {
            this.STATIC_Wards.push(item)
          }
        })
      }
      this.open = true;
      this.editMode = false;
    },
    // 编辑
    handleUpdate (row) {
      this.resetForm();
      this.form = JSON.parse(JSON.stringify(row));
      let oneLevelWarehouseIdArr = this.form.oneLevelWarehouseIds ? this.form.oneLevelWarehouseIds.split(';') : []
      let arr1 = this.form.leaderNames ? this.form.leaderNames.split(';') : []
      this.$set(this.form, 'leadersName', arr1)
      this.$set(this.form, 'oneLevelWarehouseIdArr', oneLevelWarehouseIdArr)
   
      if (this.form.oneLevelWarehouses) {
        this.form.oneLevelWarehouses.map(item => {
          let m = this.STATIC_OneLevelWarehouses.find(e => e.id == item.id)
          if (!m) {
            this.STATIC_OneLevelWarehouses.push(item)
          }
        })
      }
      
      this.form.sharedDeptIds = this.form.sharedDeptIds ? this.form.sharedDeptIds.split(';') : []
      let sharedDeptIdsArr = this.form.sharedDeptIds
      let arr = sharedDeptIdsArr.map(Number)
      this.$set(this.form, 'sharedDeptIdsArr', arr)
      if (this.form.sharedDeptIdsArr) {
        this.form.sharedDeptIdsArr.map((item,index) => {
          let m = this.STATIC_Depts.find(e => e.id == item.id)
          let strArr = this.form.sharedDeptNames.split(';')
          if (!m) {
            this.STATIC_Depts.push({
              id:item,
              name:strArr[index]
            })
          }
        })
      }
      let wardIdArr = this.form.wardIds ? this.form.wardIds.split(';') : []
      this.$set(this.form, 'wardIdArr', wardIdArr)
      if (this.form.wards) {
        this.form.wards.map(item => {
          let m = this.STATIC_Wards.find(e => e.id == item.id)
          if (!m) {
            this.STATIC_Wards.push(item)
          }
        })
      }
      this.open = true;
      // this.getDepts("");
      this.editMode = true;
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
   
        SaveDept(this.form)
          .then((res) => {
            // if (res.successful == false) {
            //   this.$my_message(res.errorMessage,"error")
            //   return;
            // }
            this.open = false;
            this.$my_message(`执行成功`, "success");
            this.getData();
          })
          .finally((res) => {
            // this.form.state = Boolean(this.form.state);
          });
      });
    },
    resetForm () {
      this.form = {
        name: "",
        state: 1,
        oneLevelWarehouseIdArr: [],
        oneLevelWarehouseIds: '',
        wardIdArr: [],
        wardIds: '',
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑部门
    cancel () {
      if (this.editMode) {
        this.$my_confirm("确认要中断当前操作吗？", "提示", {
          type: "warning",
        })
          .then(() => {
            this.open = false;
          })
          .catch(() => { });
      } else {
        this.getDepts("");
        this.getDepts1("");
        this.open = false;
      }
    },
    // 改变当前页
    changePage (val) {
      this.$set(this.query, "pageIndex", val);
      this.getData();
    },
    handleSizeChange (val) {
      this.$set(this.query, "pageSize", val);
      this.getData();
    },

    // 删除部门
    handleDelete (row) {
      let ids = [];
      let state = 0;
      if (row && row.id) {
        ids = [row.id];
        state = row.state == 1 ? 0 : 1;
      } else {
        state = this.multipleSelection[0].state == 1 ? 0 : 1;
        let stateDatas = this.multipleSelection.filter((e) => e.state == state);
        if (stateDatas.length >= 1) {
          this.$my_message("请只选择一种状态的数据！", "warning");
          return;
        }
        ids = this.ids;
      }
      // const ids = row && row.id ? [row.id] : this.ids;
      console.log(state, 'state')

      this.$my_confirm(
        state == 0 ?
          "确认禁用当前科室吗" //"当前科室关联的有资产，确定仍然要禁用吗？"
          :
          "确认启用当前科室吗",
        "提示", {
        type: "warning",
      }
      )
        .then(() => {
          return UpdateDeptStatesById({
            ids,
            state
          });
        })
        .then(() => {
          this.$my_message(`操作成功`, "success");
          this.getData();
        })
        .catch(() => { });
    },
    // 重置
    reset () {
      this.query = {
        name: "",
        state: '',
        pageIndex: 1,
        pageSize: 10,
        orgCode :sessionStorage.getItem('orgId')
      };
      if (this.$refs["selectFilter"]) {
        this.$refs["selectFilter"].resetQuery();
      }
      this.ids = []
      this.multipleSelection = []
      this.multiple = true;

      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection()
      }
      this.getData();
    },
    queryChange () {
      this.$set(this.query, "pageIndex", 1);
      this.getData();
    },
    deptChange (val) {
      this.form.parentId = val;
    },
    userChange (val) {
    
        // 过滤出STATIC_Users中id存在于arr中的项
        const matchedUsers = this.STATIC_Users.filter(item => {
          return val.includes(item.id);
        });
        this.form.leaderNames = matchedUsers.map(item =>(item.no+''+item.name)).join(';');
      this.form.leaders = val.join(';');
    },
    warehouseChange (arr) {
      this.form.oneLevelWarehouseIds = arr.join(';')
    },
    sharedDeptChange(arr){
      this.form.sharedDeptIds = arr
    },
    // tagClose(tag) {
    //   this.tags.splice(tag, 1);
    // },
    tagsSubmit(){
      if(this.share.sharedDeptIdsArr.length<2){
        this.$message({
          message: '至少选择两个科室才形成共享',
          type: 'warning'
        });
        return
      }
      let sharedDeptIds = this.share.sharedDeptIdsArr
      SaveDeptShare({sharedDeptIds}).then(res=>{
        this.$refs.multipleTable.clearSelection()
        this.getData()
        this.dialogVisible = false
        this.$my_message(`操作成功`, "success");
      })
    },
    sharedDeptIdsChange(val){
      this.$forceUpdate()
    },
    shareEvt () {
      if(this.multipleSelection.length<2){
        this.$message({
          message: '至少选择两个科室才形成共享',
          type: 'warning'
        });
        return
      }
      this.share.sharedDeptIdsArr = this.ids
      this.dialogVisible = true
    },
    handleClose () {
      
      this.dialogVisible = false
    },
    wardChange (arr) {
      this.form.wardIds = arr.join(';')
    },
    // 病区信息
    getWards1 (keyWord) {
      return new Promise((resolve, reject) => {
        let query = { ...this.defaultAllQueryParams };
        query.keyWord = keyWord
        query.state = 1
        GetWards(query)
          .then(response => {
            if (response && response.returnData) {
              this.STATIC_Wards = response.returnData.data;
              resolve(response.returnData.data);
            } else {
              reject(response);
            }
          })
      })
    },
  },
  mounted () {
    this.getData();
    this.getDepts("");
    this.getDepts1("");
    this.getUsers("");
    this.getOneLevelWarehouses('');
    this.getWards1("");
  },
};
</script>

<style lang="scss" scoped>
.center {
  padding: 5px;
  min-height: 33px;
  //border: 1px solid #333;
  box-shadow: 0px 0px 0px 1px#3333333d;
  .el-tag {
    margin: 2px 3px;
  }
}
</style>
